export default "__VITE_ASSET__c7752839__"